export const ADD_NEW_TICKET = "ADD_NEW_TICKET";
export const ADD_NEW_TICKET_SUCCESS = "ADD_NEW_TICKET_SUCCESS";
export const ADD_NEW_TICKET_FAIL = "ADD_NEW_TICKET_FAIL";

export const GETTING_TICKET_CONTENT_DATA = "GETTING_TICKET_CONTENT_DATA";
export const GETTING_TICKET_CONTENT_DATA_SUCCESS =
  "GETTING_TICKET_CONTENT_DATA_SUCCESS";
export const GETTING_TICKET_CONTENT_DATA_FAILED =
  "GETTING_TICKET_CONTENT_DATA_FAILED";

export const TICKET_DETAILS_LISTING_DATA = "TICKET_DETAILS_LISTING_DATA";
export const TICKET_DETAILS_LISTING_DATA_SUCCESS =
  "TICKET_DETAILS_LISTING_DATA_SUCCESS";
export const TICKET_DETAILS_LISTING_DATA_FAILURE =
  "TICKET_DETAILS_LISTING_DATA_FAILURE";

export const TICKET_CITIES_SUGGESTION_DATA = "TICKET_CITIES_SUGGESTION_DATA";
export const TICKET_CITIES_SUGGESTION_DATA_SUCCESS =
  "TICKET_CITIES_SUGGESTION_DATA_SUCCESS";
export const TICKET_CITIES_SUGGESTION_DATA_FAILURE =
  "TICKET_CITIES_SUGGESTION_DATA_FAILURE";
